<template>
  <div class="scriptsExamineListContainer">
    <section class="tab-container">
      <ul class="tabs">
        <li
          :class="{ active: activeName === '0' }"
          @click="handleTypeClick('0')"
        >
          剧目
        </li>
        <li
          :class="{ active: activeName === '1' }"
          @click="handleTypeClick('1')"
        >
          剧集
        </li>
      </ul>
      <el-button size="mini" type="primary" @click="toAdd()">
        {{ activeName == 0 ? "创建剧目" : "创建剧集" }}
      </el-button>
    </section>

    <!--    筛选栏-->
    <div class="searchContainer" v-if="activeName != 6">
      <!-- <el-date-picker
        v-model="searchDuration"
        type="daterange"
        align="right"
        unlink-panels
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        value-format="timestamp"
        @change="handleFilterChange"
      >
      </el-date-picker> -->
      <el-input
        placeholder="请输入关键词"
        v-model="searchKey"
        clearable
        class="searchKeyInput"
        @change="handleFilterChange"
      >
      </el-input>
    </div>

    <ul class="statusBtns">
      <li
        v-for="(item, index) in tabs"
        :key="index"
        @click="handleStatusClick(index)"
        class="statusBtn"
        :class="{ active: statusIndex == index }"
      >
        {{ item.name }}
      </li>
    </ul>

    <div class="innerContainer">
      <ul class="scriptList">
        <li v-for="(item, index) in list" :key="index">
          <div
            class="cover-container"
            v-if="item.coverList && item.coverList.length > 0"
          >
            <img
              :src="item.coverList[0]"
              class="cover"
              @click="toDetail(item)"
            />
            <div
              class="payIcon"
              v-if="
                (activeName == 0 && item.chargeDramaList.length > 0) ||
                (activeName == 1 && item.chargeEnable)
              "
            >
              付费
            </div>
          </div>
          <div class="info-box">
            <div class="infoContainer">
              <div class="titleContainer">
                <p class="title" @click="toDetail(item)">
                  {{ item.title }}
                </p>
                <p class="noPassReason" v-if="item.status == 7">
                  未通过原因：{{ item.auditReason || "无" }}
                </p>
              </div>
              <div class="timeContainer">
                <p class="create-time">
                  {{ timestampToDatetime(item.createdDate) }}
                </p>
              </div>
            </div>
            <div
              class="infoContainer"
              style="display: block"
              v-if="item.status != 7"
            >
              <p class="status">
                <span :class="convertStatus(item.status)">
                  {{ item.status | getStatusName }}
                </span>
              </p>
            </div>
            <div
              class="collectionContain"
              v-if="activeName == 1 && item.seriesName"
            >
              <img
                src="../../../assets/shortPlay/mainIcon.png"
                class="collectionIcon"
              />
              <div class="collectionName">{{ item.seriesName }}</div>
            </div>
            <div class="infoContainer action-bar">
              <div class="ext-info" v-if="item.status == 6">
                <span v-if="activeName == 0">视频 {{ item.currNum }}</span>
                <img
                  src="../../../assets/shortPlay/line.png"
                  class="lineIcon"
                  v-if="activeName == 0"
                />
                <span v-if="item.digest"
                  >展现 {{ item.digest.playTimes || 0 }}</span
                >
                <span v-if="item.digest"
                  >转发 {{ item.digest.shareTimes || 0 }}</span
                >
                <span v-if="activeName == 0 && item.digest"
                  >收藏 {{ item.digest.collectTimes || 0 }}</span
                >
              </div>
              <div class="actionContainer" v-if="statusIndex != 6">
                <p class="btns" v-if="item.status == 6 || item.status == 7">
                  <span @click="toEdit(item)">{{
                    activeName == 0 ? "编辑剧目" : "修改"
                  }}</span>
                </p>
                <p class="btns" v-if="activeName == 1 && item.status == 6">
                  <span @click="showComments(item)">查看评论</span>
                </p>
                <p class="btns">
                  <span @click="toDelete(item, index)">删除</span>
                </p>
              </div>
            </div>
          </div>
        </li>
      </ul>
      <el-empty
        description="暂无作品，赶紧去创作吧"
        v-if="list.length === 0"
      ></el-empty>
      <el-pagination
        background
        :current-page="currentPage"
        :page-size="pageSize"
        layout="total, prev, pager, next, jumper"
        :total="total"
        @current-change="handleCurrentChange"
      />
      <div class="clear"></div>
    </div>

    <el-dialog
      :visible.sync="commentVisible"
      width="920px"
      top="5vh"
      class="commentContainer"
    >
      <div class="scriptActiveContainer">
        <el-image
          class="cover"
          fit="cover"
          :src="scriptActive.coverList[0]"
          :preview-src-list="scriptActive.coverList"
          v-if="scriptActive.coverList.length > 0"
        />
        <div>
          <p class="scriptTitle">{{ scriptActive.title }}</p>
          <p class="scriptTime">
            {{ timestampToDatetime(scriptActive.createdDate) }}
          </p>
        </div>
      </div>
      <!-- <p class="commentCount">共{{ scriptActive.comment_num }}条评论</p> -->
      <ul
        class="commentList"
        v-infinite-scroll="getComments"
        infinite-scroll-disabled="commentBusy"
        style="overflow-y: auto"
      >
        <li v-for="(item, index) in commentList" :key="index">
          <img
            src="../../../assets/commentIcon/light.png"
            class="specialIcon"
            v-if="item.tag_id == 1"
          />
          <img
            src="../../../assets/commentIcon/god.png"
            class="specialIcon"
            v-if="item.tag_id == 2"
          />
          <div class="headContainer">
            <img :src="item.u_avatar" class="head" />
            <p class="userName">{{ item.u_nickname }}</p>
          </div>
          <div class="contentContainer">
            <p class="isTop" v-if="item.c_is_top > 0">置顶</p>
            <div class="content" :class="{ contentIsTop: item.c_is_top > 0 }">
              {{ item.c_content }}
            </div>
          </div>
          <el-image
            fit="cover"
            :src="item.c_content_img_url"
            :preview-src-list="[item.c_content_img_url]"
            class="commentImg"
            :style="item | commentImgSize(findNearesttargetber)"
            v-if="item.c_content_img_url"
          />
          <div class="actionContainer">
            <p class="commentTime">{{ item.display_time }}</p>
            <div class="actions">
              <div class="action" @click="replyToggle(item)">
                <img
                  src="../../../assets/commentIcon/comment.png"
                  class="actionIcon"
                />
                <p class="actionName">
                  {{
                    item.showReply
                      ? "取消回复"
                      : item.comment_num > 0
                      ? item.comment_num
                      : "回复"
                  }}
                </p>
              </div>
              <div class="action">
                <img
                  src="../../../assets/commentIcon/like.png"
                  class="actionIcon"
                />
                <p class="actionName">{{ item.like_num }}</p>
              </div>
              <div class="action" @click="commentTop(item)" v-if="topAuth">
                <img
                  src="../../../assets/commentIcon/top.png"
                  class="actionIcon"
                  v-if="item.c_is_top == 0"
                />
                <p class="actionName">
                  {{ item.c_is_top > 0 ? "取消置顶" : "置顶" }}
                </p>
              </div>
              <div class="action" @click="commentDelete(index)">
                <img
                  src="../../../assets/commentIcon/delete.png"
                  class="actionIcon"
                />
                <p class="actionName">删除</p>
              </div>
            </div>
          </div>
          <div class="commentReplyContainer" v-show="item.showReply">
            <el-input
              type="textarea"
              :rows="3"
              placeholder="积极回复用户，可以吸引更多的人评论哦～"
              v-model="item.reply"
              :autosize="true"
              resize="none"
            >
            </el-input>
            <p
              class="replyBtn"
              :class="{ hasContent: item.reply != '' }"
              @click="commentReply(index)"
            >
              发布
            </p>
            <div class="clear"></div>
          </div>
          <ul
            class="subCommentsContainer"
            v-if="item.children && item.children.length"
          >
            <li v-for="(subItem, subIndex) in item.children" :key="subIndex">
              <img
                src="../../../assets/commentIcon/light.png"
                class="specialIcon"
                v-if="subItem.tag_id == 1"
              />
              <img
                src="../../../assets/commentIcon/god.png"
                class="specialIcon"
                v-if="subItem.tag_id == 2"
              />
              <div class="headContainer">
                <img :src="subItem.u_avatar" class="head" />
                <p class="userName">{{ subItem.u_nickname }}</p>
              </div>
              <div class="contentContainer">
                <p class="isTop" v-if="subItem.c_is_top > 0">置顶</p>
                <div
                  class="content"
                  :class="{ contentIsTop: subItem.c_is_top > 0 }"
                >
                  回复<span class="toUserName">{{ subItem.to_u_nickname }}</span
                  >{{ subItem.c_content }}
                </div>
              </div>
              <el-image
                fit="cover"
                :src="subItem.c_content_img_url"
                :preview-src-list="[subItem.c_content_img_url]"
                class="commentImg"
                :style="subItem | commentImgSize(findNearesttargetber)"
                v-if="subItem.c_content_img_url"
              />
              <div class="actionContainer">
                <p class="commentTime">{{ subItem.display_time }}</p>
                <div class="actions">
                  <div class="action" @click="replyToggle(subItem)">
                    <img
                      src="../../../assets/commentIcon/comment.png"
                      class="actionIcon"
                    />
                    <p class="actionName">
                      {{
                        subItem.showReply
                          ? "取消回复"
                          : subItem.comment_num > 0
                          ? subItem.comment_num
                          : "回复"
                      }}
                    </p>
                  </div>
                  <div class="action">
                    <img
                      src="../../../assets/commentIcon/like.png"
                      class="actionIcon"
                    />
                    <p class="actionName">{{ subItem.like_num }}</p>
                  </div>
                  <div class="action" @click="commentDelete(index, subIndex)">
                    <img
                      src="../../../assets/commentIcon/delete.png"
                      class="actionIcon"
                    />
                    <p class="actionName">删除</p>
                  </div>
                </div>
              </div>
              <div class="commentReplyContainer" v-show="subItem.showReply">
                <el-input
                  type="textarea"
                  :rows="3"
                  placeholder="积极回复用户，可以吸引更多的人评论哦～"
                  v-model="subItem.reply"
                  :autosize="true"
                  resize="none"
                >
                </el-input>
                <p
                  class="replyBtn"
                  :class="{ hasContent: subItem.reply != '' }"
                  @click="commentReply(index, subIndex)"
                >
                  发布
                </p>
                <div class="clear"></div>
              </div>
            </li>
          </ul>
          <p
            class="moreComment"
            v-if="
              item.children &&
              item.children.length &&
              item.children.length == item.comment_num > 1 &&
              item.comment_num > 1
            "
            @click="moreComment(index)"
          >
            点击展开{{ item.comment_num - 1 }}条评论
          </p>
        </li>
      </ul>
    </el-dialog>

    <el-dialog
      title="请完成实名认证"
      :visible.sync="certificationVisible"
      class="certificationInfoContainer"
      width="1026px"
    >
      <p class="title">
        应网络实名制要求，完成实名认证后才可以发表文章视频等内容，以保护账号安全。
      </p>
      <div class="borderContainer">
        <div>
          <p class="infoTitle">1、打开“顶端新闻”App</p>
          <p class="info">登录当前账号或扫下方二维码下载“顶端新闻”App</p>
          <img
            src="../../../assets/85d81507ebe84f210b224bf8e02c6d76966336a7fff89e02e5f088ed492cce1f.png"
            class="qrCode"
          />
        </div>
        <div>
          <p class="infoTitle">2、打开“我的”</p>
          <p class="info">点击“实名认证”完成实名认证</p>
          <img
            src="../../../assets/shiming@2x.png"
            class="app"
            v-if="u_cert != 1"
          />
          <img src="../../../assets/shenqing@2x.png" class="app" v-else />
        </div>
      </div>
    </el-dialog>

    <BanDialog
      ref="banShow"
      :isShow="isBanned"
      :allowClose="true"
      @closeBan="isBanned = false"
    ></BanDialog>
  </div>
</template>

<script>
import {
  NEWS_HOST,
  RESOURCE_HOST,
  SWNEWS_HOST,
  TOPNEWS_HOST,
} from "../../../constants/apiHosts";
import { SHORT_PLAY_STATUS_DETAIL } from "../../../constants/manuscript";
import BanDialog from "../../../components/banDialog.vue";

export default {
  data() {
    return {
      activeName: "0",
      statusIndex: 0,
      searchKey: "",
      searchDuration: [],
      list: [],
      pageSize: 10,
      currentPage: 1,
      total: 1,
      u_cert: 0,
      u_cert_status: 0,
      certificationVisible: false,
      commentVisible: false,
      scriptActive: {
        coverList: [],
      },
      commentPage: 1,
      commentList: [],
      commentBusy: false,
      isBanned: false,
      topAuth: false,
      shortPlayLength: 0,
    };
  },
  components: {
    BanDialog,
  },
  filters: {
    getStatusName: function (status) {
      let text = "审核中";
      switch (status) {
        case 6:
          text = "已发布";
          break;
        case 7:
          text = "未通过";
          break;
        default:
          text = "审核中";
      }
      return text;
    },
    commentImgSize(item, compute) {
      let rate = 1;
      if (item.c_content_img_width) {
        rate = compute(
          [0.5625, 1, 1.3333],
          item.c_content_img_width / item.c_content_img_height
        );
      }
      switch (rate) {
        case 0.5625:
          // 9:16
          return "width:180px;height:320px;";
        case 1:
          // 1:1
          return "width:240px;height:240px;";
        case 1.3333:
          // 4:3
          return "width:320px;height:240px;";
        default:
          return "width:240px;height:240px;";
      }
    },
  },
  computed: {
    tabs: function () {
      return SHORT_PLAY_STATUS_DETAIL;
    },
  },
  created() {
    this.u_cert_status = localStorage.getItem("u_cert_status");
    this.u_cert = localStorage.getItem("u_cert");

    setTimeout(() => {
      this.u_cert_status = localStorage.getItem("u_cert_status");
      this.u_cert = localStorage.getItem("u_cert");
    }, 3000);

    this.getList();
    this.getUserLevelList();

    this.getPublishCount();
  },
  mounted() {},
  methods: {
    handleTypeClick(type) {
      this.activeName = type;
      this.statusIndex = 0;
      this.currentPage = 1;
      this.getList();
    },
    handleFilterChange() {
      this.currentPage = 1;
      this.getList();
    },
    handleStatusClick(index) {
      this.statusIndex = index;
      this.currentPage = 1;
      this.getList();
    },
    reset() {
      this.statusIndex = 0;
      this.searchKey = "";
      this.searchDuration = [];
      this.currentPage = 1;
      this.getList();
    },
    getList() {
      let url = `${TOPNEWS_HOST}${
        this.activeName == 0 ? "/api/md/series/myList" : "/api/md/drama/myList"
      }?page=${this.currentPage}&size=${this.pageSize}&title=${
        this.searchKey
      }&status=${this.tabs[this.statusIndex].id}`;
      if (this.searchDuration && this.searchDuration.length) {
        url += `&start_time=${this.searchDuration[0] / 1000}&end_time=${
          this.searchDuration[1] / 1000 + 86400
        }`;
      }
      this.$axios.get(url).then((res) => {
        if (res.data.code == 0) {
          this.list = res.data.data.list;
          if (this.currentPage == 1) {
            this.total = res.data.data.total;
          }
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    getPublishCount() {
      this.$axios
        .get(
          `${TOPNEWS_HOST}/api/md/series/myList?page=1&size=10&title=&status=6`
        )
        .then((res) => {
          if (res.data.code == 0) {
            this.shortPlayLength = res.data.data.total;
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getList();

      document.getElementsByTagName("html")[0].scrollTop = 0;
    },
    convertStatus(status) {
      switch (status) {
        case 6:
          return "success";
        case 7:
          return "error";
        default:
          return "info";
      }
    },
    toDetail(item) {
      return;
      if (this.statusIndex == 6) {
        // 已下线
        return;
      }
      let _this = this;
      let query = {
        scriptId: item.nm_id,
        nid: item.n_id,
        isMine: 1,
        isPub: _this.statusIndex == 1 || _this.statusIndex == 4 ? 1 : 0,
      };
      if (!item.n_id || item.status == 3 || item.status == 4) {
        return;
      }
      let routeUrl = this.$router.resolve({
        path: "/scriptDetail",
        query: query,
      });
      window.open(routeUrl.href, "_blank");
    },
    toAdd() {
      if (this.u_cert != 1) {
        this.certificationVisible = true;
        return;
      }
      let banData = localStorage.getItem("banData");
      if (banData) {
        banData = JSON.parse(banData);
      }
      if (banData.ban_type == 1 && banData.ban_range_type.indexOf("1") > -1) {
        this.$refs.banShow.getReason(localStorage.getItem("token"));
        this.isBanned = true;
        return;
      }

      if (this.activeName == 0) {
        this.$router.push({
          path: "/shortPlay/detail",
        });
      } else if (this.activeName == 1 && this.shortPlayLength == 0) {
        this.$message({
          message: "请先去创建剧目或者等待剧目审核",
          type: "warning",
        });
      } else {
        this.$router.push({
          path: "/episode",
        });
      }
    },
    toEdit(item) {
      if (this.u_cert != 1) {
        this.certificationVisible = true;
        return;
      }
      let banData = localStorage.getItem("banData");
      if (banData) {
        banData = JSON.parse(banData);
      }
      if (banData.ban_type == 1 && banData.ban_range_type.indexOf("1") > -1) {
        this.$refs.banShow.getReason(localStorage.getItem("token"));
        this.isBanned = true;
        return;
      }

      if (this.activeName == 0) {
        this.$router.push({
          path: "/shortPlay/detail?id=" + item.id,
        });
      } else if (this.activeName == 1 && this.shortPlayLength == 0) {
        this.$message({
          message: "请先去创建剧目或者等待剧目审核",
          type: "warning",
        });
      } else {
        this.$router.push({
          path: "/episode?id=" + item.id,
        });
      }
    },
    toDelete(item, index) {
      this.$confirm(
        this.activeName == 0
          ? "确认删除该短剧吗？若确认将同步删除该短剧下的全部剧集"
          : "确认删除该剧集吗？",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          this.$axios
            .get(
              this.activeName == 0
                ? `${TOPNEWS_HOST}/api/md/series/remove?id=${item.id}`
                : `${TOPNEWS_HOST}/api/md/drama/remove?id=${item.id}`
            )
            .then((res) => {
              if (res.data.code == 0) {
                this.$message({
                  message: "删除成功",
                  type: "success",
                });

                this.getList();
              } else {
                this.$message.error(res.data.msg);
              }
            });
        })
        .catch(() => {});
    },
    operateComment(item) {
      this.$axios
        .post(`${RESOURCE_HOST}/api/manuscript/opreateComment`, {
          n_id: item.n_id,
          is_allow_comment: item.n_is_allow_comment == "Y" ? "N" : "Y",
          global_id: item.global_id,
        })
        .then((res) => {
          if (res.data.code == 0) {
            this.$message({
              message: "操作成功",
              type: "success",
            });

            item.n_is_allow_comment =
              item.n_is_allow_comment == "Y" ? "N" : "Y";
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    showComments(item) {
      this.scriptActive = item;
      this.commentList = [];
      this.commentPage = 0;
      this.commentBusy = false;
      this.commentVisible = true;

      this.getComments(item);
    },
    getComments(item) {
      this.commentBusy = true;
      this.commentPage++;
      this.$axios
        .post(`${SWNEWS_HOST}/api/comment/list`, {
          n_id: item.id,
          type: 1,
          page: this.commentPage,
          page_size: 10,
          comment_type: 6,
        })
        .then((res) => {
          if (res.data.code == 0) {
            res.data.data.forEach((element) => {
              element.reply = "";
              element.showReply = false;

              if (!element.children) {
                element.children = [];
              }

              if (element.children && element.children.length) {
                element.children.forEach((item) => {
                  item.reply = "";
                  item.showReply = false;
                });
              }
            });
            this.commentList = this.commentList.concat(res.data.data);

            this.$nextTick(() => {
              if (res.data.data.length > 0) {
                this.commentBusy = false;
              }
            });
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    moreComment(index) {
      this.$axios
        .post(`${SWNEWS_HOST}/api/comment/list`, {
          n_id: this.scriptActive.id,
          type: 2,
          page: 1,
          page_size: 100,
          c_p_id: this.commentList[index].c_id,
          comment_type: 6,
        })
        .then((res) => {
          if (res.data.code == 0) {
            res.data.data.forEach((element) => {
              element.reply = "";
              element.showReply = false;
            });
            this.commentList[index].children = res.data.data;
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    replyToggle(item) {
      let banData = localStorage.getItem("banData");
      if (banData) {
        banData = JSON.parse(banData);
      }

      if (
        !item.showReply &&
        banData.ban_type == 1 &&
        banData.ban_range_type.indexOf("2") > -1
      ) {
        this.$refs.banShow.getReason(localStorage.getItem("token"));
        this.isBanned = true;
      } else {
        item.showReply = !item.showReply;
      }
    },
    commentReply(index, subIndex) {
      let isOne = true;
      if (subIndex !== undefined) {
        // 二级评论
        isOne = false;
      }

      if (
        (isOne
          ? this.commentList[index].reply
          : this.commentList[index].children[subIndex].reply) == ""
      ) {
        return;
      }

      this.$axios
        .post(`${SWNEWS_HOST}/api/comment/comment`, {
          type: 2,
          content: isOne
            ? this.commentList[index].reply
            : this.commentList[index].children[subIndex].reply,
          n_id: this.scriptActive.id,
          n_type: 9,
          n_title: this.scriptActive.title,
          n_cover_url: JSON.stringify(this.scriptActive.coverList),
          c_id: isOne
            ? this.commentList[index].c_id
            : this.commentList[index].children[subIndex].c_id,
          to_u_id: isOne
            ? this.commentList[index].u_id
            : this.commentList[index].children[subIndex].u_id,
        })
        .then((res) => {
          if (res.data.code == 0) {
            this.$message({
              message: "评论成功",
              type: "success",
            });

            if (isOne) {
              this.commentList[index].showReply = false;
              this.commentList[index].reply = "";
            } else {
              this.commentList[index].children[subIndex].showReply = false;
              this.commentList[index].children[subIndex].reply = "";
            }

            this.moreComment(index);
            this.getList();
            this.commentList[index].comment_num++;
            this.scriptActive.comment_num++;
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    commentTop(item) {
      this.$axios
        .post(`${NEWS_HOST}/api/comment/operateTop`, {
          c_id: item.c_id,
          is_top: item.c_is_top > 0 ? 2 : 1,
        })
        .then((res) => {
          if (res.data.code == 0) {
            this.commentList = [];
            this.commentPage = 0;
            this.commentBusy = false;

            this.getComments();
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    commentDelete(index, subIndex) {
      let isOne = true;
      if (subIndex !== undefined) {
        // 二级评论
        isOne = false;
      }

      this.$confirm("确定要删除该条评论吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$axios
            .post(`${NEWS_HOST}/api/comment/del`, {
              c_id: isOne
                ? this.commentList[index].c_id
                : this.commentList[index].children[subIndex].c_id,
            })
            .then((res) => {
              if (res.data.code == 0) {
                this.$message({
                  message: "删除成功",
                  type: "success",
                });

                if (isOne) {
                  // 一级评论删除
                  this.commentList.splice(index, 1);
                } else {
                  // 二级评论删除
                  this.moreComment(index);
                }

                this.getList();
                this.commentList[index].comment_num--;
                this.scriptActive.comment_num--;
              } else {
                this.$message.error(res.data.msg);
              }
            });
        })
        .catch(() => {});
    },
    findNearesttargetber(arr, target) {
      let mid;
      let l = 0;
      let r = arr.length - 1;
      // 保证指针最终停留在相邻的两个数,所以这里是判断是否大于1
      while (r - l > 1) {
        mid = Math.floor((l + r) / 2);
        // 如果目标数比中间小，所以范围在左边
        if (target < arr[mid]) {
          r = mid;
        } else {
          l = mid;
        }
      }
      return Math.abs(target - arr[l]) <= Math.abs(target - arr[r])
        ? arr[l]
        : arr[r];
    },
    getUserLevelList() {
      this.$axios
        .get(`${SWNEWS_HOST}/api/creatorScore/getUserLevelList`, {})
        .then((res) => {
          if (res.data.code == 0) {
            res.data.data.user_privilege_list.forEach((item) => {
              if (item.privilege_name == "评论置顶" && item.is_open == 1) {
                this.topAuth = true;
              }
            });
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    timestampToDatetime(timestamp) {
      let dateObj = new Date(timestamp);
      let year = dateObj.getFullYear();
      let month = dateObj.getMonth() + 1;
      let day = dateObj.getDate();
      let hours = dateObj.getHours();
      let minutes = dateObj.getMinutes();
      if (month < 10) {
        month = "0" + month;
      }
      if (day < 10) {
        day = "0" + day;
      }
      if (hours < 10) {
        hours = "0" + hours;
      }
      if (minutes < 10) {
        minutes = "0" + minutes;
      }
      return year + "-" + month + "-" + day + " " + hours + ":" + minutes;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../styles/variables";

.scriptsExamineListContainer {
  padding: 0 32px;
  position: relative;
  background-color: #ffffff;
  //box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
  border-radius: 8px;
  overflow: hidden;

  .certificationInfoContainer {
    /deep/.el-dialog__header {
      padding: 20px 32px;

      .el-dialog__title {
        font-size: 16px;
        font-family: PingFang-SC-Heavy, PingFang-SC;
        font-weight: 800;
        color: #333333;
        line-height: 22px;
      }
    }

    /deep/.el-dialog__body {
      padding: 10px 32px 41px 32px;

      .title {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
        line-height: 20px;
        margin-bottom: 20px;
      }

      .borderContainer {
        height: 255px;
        border-radius: 6px;
        border: 1px solid #dcdfe6;
        display: flex;
        padding: 28px 32px 0 32px;
        justify-content: space-between;

        div {
          flex: 1;

          .infoTitle {
            font-size: 16px;
            font-family: PingFang-SC-Heavy, PingFang-SC;
            font-weight: 800;
            color: #333333;
            line-height: 22px;
            margin-bottom: 10px;
          }

          .info {
            font-size: 16px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #333333;
            line-height: 22px;
          }

          .qrCode {
            width: 118px;
            margin: 22px 0 0 117px;
          }

          .app {
            width: 198px;
            margin: 20px 0 0 43px;
          }
        }
      }
    }
  }

  .tabs {
    display: flex;

    li {
      padding: 10px 0 20px;
      margin-right: 56px;
      font-size: 18px;
      color: #333333;
      font-weight: bold;
      cursor: pointer;
    }
    li.active {
      border-bottom: 3px solid #ea0e0e;
    }
  }

  /deep/.el-range-separator {
    width: 22px !important;
  }

  /deep/.el-tabs__nav-wrap::after {
    height: 0;
  }
  /deep/.el-tabs__nav {
    padding-bottom: 10px;

    .el-tabs__item {
      font-size: 18px;
      color: $text-color-main;
    }
  }
  /deep/.el-tabs__header {
    margin-bottom: 0;
  }

  /deep/.el-dropdown .el-button span {
    font-size: 16px;
  }

  .tab-container {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-top: 20px;
  }

  .searchContainer {
    margin-top: 32px;
    display: flex;
    align-items: center;

    .el-input {
      width: 220px;
      margin: 0;
    }

    .el-date-editor {
      width: 250px;
      margin-right: 10px;
    }
  }

  .statusBtns {
    margin-top: 16px;
    display: inline-flex;
    font-size: 14px;
    color: $text-color-sub;

    li {
      line-height: 40px;
      margin-right: 20px;
    }

    li.active {
      color: $theme-color;
      font-weight: bold;
    }

    .statusBtn {
      cursor: pointer;
    }
  }

  .innerContainer {
    min-height: calc(100vh - 255px);
    padding-bottom: 20px;

    .el-button {
      margin-right: 10px;
    }

    .el-button + .el-button {
      margin: 0 10px 10px 0;
    }

    .el-pagination {
      float: right;
      margin: 20px 0 0 0;
    }

    .searchKeyInput {
      width: 180px;
    }

    .scriptList {
      li {
        border-bottom: 1px solid #edf1f8;
        padding: 16px 0;
        display: flex;
        min-height: 90px;
        box-sizing: content-box;
        justify-content: space-between;

        .cover-container {
          width: 116px;
          height: 155px;
          border-radius: 6px;
          overflow: hidden;
          background: $img-bg-color;
          margin-right: 16px;
          flex-shrink: 0;
          position: relative;

          .cover {
            height: 100%;
            width: 100%;
            object-fit: cover;
            cursor: pointer;
          }

          .payIcon {
            width: 28px;
            line-height: 16px;
            border-radius: 2px;
            background: #ffd499;
            color: #997508;
            font-family: "PingFang SC";
            font-size: 10px;
            font-weight: 400;
            padding: 0 4px;
            position: absolute;
            left: 4px;
            top: 4px;
          }
        }

        .info-box {
          flex: 1;
          position: relative;
          width: 0;

          .infoContainer {
            display: flex;
            justify-content: space-between;

            .titleContainer {
              width: calc(100% - 180px);
            }

            .noPassReason {
              font-size: 14px;
              font-family: PingFang SC-常规, PingFang SC;
              font-weight: normal;
              color: #d80c18;
              line-height: 20px;
              background: rgba(215, 12, 24, 0.05);
              padding: 4px 12px;
              margin-top: 12px;
              display: inline-block;
            }

            .title {
              width: 100%;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              color: $text-color-main;
              font-weight: bold;
              font-size: 16px;
              //cursor: pointer;
            }

            .outlineList {
              cursor: default;
            }

            .timeContainer {
              display: flex;
            }

            .create-time {
              color: #999999;
              font-size: 14px;
              margin-left: 8px;
            }

            .status {
              margin: 12px 12px 0 0;

              span {
                display: inline-block;
                padding: 3px 12px;
              }
              @include status() .status-info {
                color: #adb3c8;
                margin-left: 10px;
                font-weight: 800;
              }
            }

            .actionContainer {
              display: flex;
              line-height: 20px;

              .btns {
                margin-left: 20px;
                color: #5574e7;
                font-size: 14px;
                cursor: pointer;
              }
            }
          }

          .collectionContain {
            width: fit-content;
            display: flex;
            align-items: center;
            border-radius: 4px;
            border: 1px solid #eee;
            padding: 5px 12px;
            margin-top: 8px;

            .collectionIcon {
              height: 16px;
              margin-right: 2px;
            }

            .collectionName {
              color: #333333;
              font-family: "PingFang SC";
              font-size: 12px;
              font-weight: 400;
            }
          }

          .infoContainer.action-bar {
            width: 100%;
            position: absolute;
            left: 0;
            bottom: 0;

            .ext-info {
              display: flex;
              align-items: center;

              span {
                margin-right: 20px;
                color: #999999;
                font-family: "PingFang SC";
                font-size: 14px;
                font-weight: 400;
                line-height: 20px;
              }

              .lineIcon {
                margin-right: 20px;
              }
            }
            .actionContainer {
              flex: 1;
              justify-content: flex-end;
            }
          }
        }
      }
    }

    .el-empty {
      min-height: calc(100vh - 340px);
    }
  }

  /deep/.commentContainer {
    .el-dialog__body {
      padding-top: 0;

      .scriptActiveContainer {
        width: 840px;
        display: flex;
        margin-bottom: 32px;

        .cover {
          width: 160px;
          height: 90px;
          border-radius: 6px;
          margin-right: 20px;
        }

        .scriptTitle {
          font-size: 16px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 600;
          color: #333333;
          line-height: 22px;
          height: 66px;
        }

        .scriptTime {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #999999;
          line-height: 20px;
          margin-top: 4px;
        }
      }

      .commentCount {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;
        line-height: 20px;
        border-bottom: 1px solid #edf1f8;
        padding-bottom: 16px;
      }

      .commentList {
        height: calc(90vh - 260px);
        overflow-x: hidden;

        li {
          padding: 20px 0;
          border-top: 1px solid #edf1f8;
          position: relative;

          .specialIcon {
            height: 96px;
            position: absolute;
            right: 0;
            top: 10px;
          }

          .headContainer {
            display: flex;
            align-items: center;

            .head {
              width: 28px;
              height: 28px;
              border-radius: 50%;
              margin-right: 12px;
            }

            .userName {
              font-size: 14px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #333333;
              line-height: 20px;
            }
          }

          .contentContainer {
            position: relative;
            margin-top: 12px;

            .isTop {
              width: 40px;
              line-height: 20px;
              background: #ea0e0e;
              border-radius: 4px;
              font-size: 12px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #ffffff;
              text-align: center;
              position: absolute;
              left: 0;
              top: 1px;
            }

            .content {
              font-size: 16px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #333333;
              line-height: 22px;
            }

            .contentIsTop {
              text-indent: 45px;
            }
          }

          .commentImg {
            margin-top: 17px;
            display: block;
          }

          .actionContainer {
            margin-top: 17px;
            display: flex;
            align-items: center;
            justify-content: space-between;

            .commentTime {
              font-size: 14px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #999999;
              line-height: 20px;
            }

            .actions {
              display: flex;

              .action {
                display: flex;
                align-items: center;
                margin-right: 32px;
                cursor: pointer;

                .actionIcon {
                  height: 18px;
                  margin-right: 4px;
                }

                .actionName {
                  font-size: 14px;
                  font-family: PingFangSC-Regular, PingFang SC;
                  font-weight: 400;
                  color: #333333;
                  line-height: 20px;
                }
              }

              .action:nth-child(2) {
                cursor: default;
              }

              .action:last-child {
                margin-right: 10px;
              }
            }
          }

          .subCommentsContainer {
            padding-left: 40px;

            .toUserName {
              color: rgb(153, 153, 153);
              padding: 0 10px;
            }

            li {
              position: relative;

              .specialIcon {
                height: 96px;
                position: absolute;
                right: 0;
                top: 10px;
              }
            }

            li:last-child {
              padding-bottom: 0;
            }
          }

          .moreComment {
            color: rgb(83, 113, 243);
            font-size: 16px;
            margin: 20px 0 0 40px;
            display: inline-block;
            cursor: pointer;
          }

          .commentReplyContainer {
            width: calc(100% - 10px);
            min-height: 140px;
            background: #f6f7f9;
            border-radius: 4px;
            margin-top: 16px;
            padding-bottom: 12px;

            .el-textarea {
              padding: 12px;
              background: #f6f7f9;
              border: 0;
              min-height: 80px;
              margin-bottom: 12px;

              textarea {
                background: #f6f7f9;
                border: 0;
                padding: 0;
              }
            }

            .replyBtn {
              width: 68px;
              line-height: 36px;
              background: rgba(234, 14, 14, 0.5);
              border-radius: 6px;
              font-size: 14px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #ffffff;
              text-align: center;
              float: right;
              margin-right: 12px;
            }

            .hasContent {
              background: #ea0e0e;
              cursor: pointer;
            }
          }
        }

        li:first-child {
          border-top: 0;
        }
      }
    }
  }
}
</style>

<style lang="scss">
.el-tooltip__popper.is-light.status-info-popper {
  box-shadow: 0 2px 14px 0 rgba(0, 0, 0, 0.12);
  color: #ec4e4e;
  border: none;

  .popper__arrow {
    border: none;
  }
}
</style>
